import { API_ENDPOINTS } from 'utils/constants';
import { AppDispatch } from 'app/store';
import { getAPI } from 'services/api/apiAsync';
import * as brand from './brandSlice';
import { setCompanyDetails, resetCompanyDetails } from './brandSlice';
import { getBrandDomain } from './utils';

export default function fetchBrandDetails() {
  return async (dispatch: AppDispatch) => {
    const domain = getBrandDomain();
    try {
      const config = {
        url: `${API_ENDPOINTS.getBrandDetails}/${domain}`,
      };
      const response = await dispatch(getAPI(config)).unwrap();
      dispatch(brand.setBrand(response));
      return response;
    } catch (error) {
      return Promise.reject(error);
    }
  };
}

export function fetchCompanyCodeDetails(companyCode: string) {
  return async (dispatch: AppDispatch) => {
    try {
      const config = {
        url: `${API_ENDPOINTS.companyCode}/${companyCode}`,
      };
      const response = await dispatch(getAPI(config)).unwrap();
      dispatch(setCompanyDetails(response));
      return response;
    } catch (error) {
      dispatch(resetCompanyDetails());
      return Promise.reject(error);
    }
  };
}
